import JSZip from "jszip";

import { normalizeCropCode } from "pages/admin/experiments/cropExtraction/cropCodes";
import { findXmlInZip, findYearInXml, parseXml } from "pages/admin/experiments/cropExtraction/parsers/xmlHelpers";
import { CropRecord, ParserResult } from "pages/admin/experiments/cropExtraction/types";

export const parseAndi = async (jszip: JSZip): Promise<ParserResult> => {
  const warnings: string[] = [];
  const found = await findXmlInZip(jszip, (rel) => {
    const lc = rel.toLowerCase();
    return lc.endsWith(".xml") && !lc.includes("geometrien/");
  });
  if (!found) return { method: "xml_parsing", crops: [], warnings: ["Could not find ANDI hauptantrag XML"] };

  const { doc, error } = parseXml(found.xml);
  if (error) return { method: "xml_parsing", crops: [], warnings: [`XML parser error: ${error}`] };

  const crops: CropRecord[] = [];
  const schlaege = Array.from(doc.getElementsByTagNameNS("*", "schlag"));

  for (const schlag of schlaege) {
    const nr = schlag.getAttribute("nr") || "";
    const bezeichnung = schlag.getAttribute("bezeichnung") || "";
    const flik = schlag.getAttribute("flik") || "";
    const cropCode = normalizeCropCode(schlag.getAttribute("kultur_fach_code"));

    // Only consider direct children of <teilschlag_liste>; nested <teilschlag>
    // elements deeper in the tree describe sub-attributes, not real splits.
    const teilschlaege = Array.from(schlag.getElementsByTagNameNS("*", "teilschlag")).filter((el) => el.parentElement?.localName === "teilschlag_liste");

    if (teilschlaege.length === 0) {
      warnings.push(`Schlag ${nr} (${bezeichnung}) has no teilschlag entries — area set to 0`);
      crops.push({
        fieldId: flik || nr,
        fieldName: bezeichnung || flik || nr,
        cropCode,
        cropDescription: "",
        areaHa: 0,
        fieldNumber: nr || undefined,
      });
    } else {
      for (const ts of teilschlaege) {
        const tsBez = ts.getAttribute("bezeichnung") || "";
        const sizeRaw = ts.getAttribute("geometrie_groesse") || "";
        const parsedArea = sizeRaw ? Number(sizeRaw.replace(/,/g, ".")) : 0;
        crops.push({
          fieldId: tsBez ? `${nr}/${tsBez}` : nr || flik,
          fieldName: bezeichnung || flik || nr,
          cropCode,
          cropDescription: "",
          areaHa: Number.isFinite(parsedArea) ? parsedArea : 0,
          fieldNumber: nr || undefined,
        });
      }
    }
  }

  if (crops.length === 0) warnings.push("No <schlag> entries were found in ANDI XML");
  return { method: "xml_parsing", crops, warnings, year: findYearInXml(doc) };
};
